// Settings Console (IT Budget; the spec's Vendor Console): vendors and how each
// one's mail is captured, the mailboxes the Invoice Collector reads, and (IT
// only) the it_settings values and the it_role_permissions list. The extraction
// prompts are edited on Admin › AI Prompts (module IT Budget).

// REACT IMPORTS
import React, { useContext, useEffect, useState } from "react";

// MSAL
import { useMsal } from "@azure/msal-react";

// CUSTOM COMPONENTS
import VendorsTab from "./VendorsTab";
import MailboxesTab from "./MailboxesTab";
import SettingsTab from "./SettingsTab";
import PermissionsTab from "./PermissionsTab";

// CONTEXT, API, CONSTANTS
import { UserContext } from "../../../context/UserContext";
import { getAPICall, postAPICall } from "../../../config/apiCalls";
import { hasAccess } from "../itBudgetUtils";

// CSS
import "../ITBudget.css";

const SettingsConsole = ({ access }) => {
	const { instance, accounts } = useMsal();
	const employeeID = useContext(UserContext);
	const canEdit = hasAccess(access, "vendor_console", "full");
	const canSettings = hasAccess(access, "settings", "full");
	const [tab, setTab] = useState("vendors");
	const [lookups, setLookups] = useState(null);

	useEffect(() => {
		postAPICall(instance, accounts[0], "/api/logs/access/add", {
			page_name: "IT Budget - Settings Console",
			employeeID: employeeID,
			notes: "Accessed the IT Budget Settings Console page",
		}).catch(() => {});
		getAPICall(instance, accounts[0], "/api/it-budget/lookups")
			.then((res) => setLookups(res.data))
			.catch(() => setLookups({}));
	}, []);

	const tabs = [
		{ id: "vendors", label: "Vendors" },
		{ id: "mailboxes", label: "Mailboxes" },
		...(canSettings
			? [
					{ id: "settings", label: "Settings" },
					{ id: "permissions", label: "Permissions" },
				]
			: []),
	];

	return (
		<div className="itBudgetPage">
			<div className="itBudgetHeader">
				<div>
					<div className="itBudgetBreadcrumb">IT Budget / Settings Console</div>
					<div className="itBudgetTitle">Settings Console</div>
					{!canEdit && <div className="itBudgetSubtitle">View only</div>}
				</div>
			</div>
			<div className="itBudgetTabs">
				{tabs.map((t) => (
					<button key={t.id} className={`itBudgetTab${tab === t.id ? " itBudgetTab--active" : ""}`} onClick={() => setTab(t.id)}>
						{t.label}
					</button>
				))}
			</div>
			{lookups && tab === "vendors" && <VendorsTab canEdit={canEdit} lookups={lookups} />}
			{lookups && tab === "mailboxes" && <MailboxesTab canEdit={canEdit} />}
			{lookups && tab === "settings" && canSettings && <SettingsTab lookups={lookups} />}
			{lookups && tab === "permissions" && canSettings && <PermissionsTab lookups={lookups} />}
		</div>
	);
};

export default SettingsConsole;
